import { toQueryString } from '@suntex.core/utils';

declare global {
  let JustTheFactsFrame: any;
  interface Window {
    JustTheFactsFrame: any;
  }
}

interface ThisJustTheFacts {
  pwaMode: boolean;
  preview: boolean;
  playerId: number;
  moduleId: number;
  moduleVariant: number;
  getProgressUrl: string;

  gameDataFormat: any;
  loadSound: (src: string, id) => void;
  endScreen: any;
  practiceMenu: any;
  changeRoundBtn: any;
  scoreboard: any;
  gameStartFunction: any;
  gameStopFunction: any;
  jtfSize: any;
  roundsInModule: number;
  veil: any;
  gameDataObject: any;
  _onVarsLoad: any;
}

export function extendJustTheFactsFrame() {
  if (lib.comsuntexsymbolsJustTheFactsFrame) {
    window.JustTheFactsFrame = lib.comsuntexsymbolsJustTheFactsFrame;

    const comsuntexsymbolsJustTheFactsFrame_constructor =
      lib.comsuntexsymbolsJustTheFactsFrame;
    const comsuntexsymbolsJustTheFactsFrame_prototype =
      lib.comsuntexsymbolsJustTheFactsFrame.prototype;

    lib.comsuntexsymbolsJustTheFactsFrame = function () {
      JustTheFactsFrame._instance = this;
      this._oldConstructor = comsuntexsymbolsJustTheFactsFrame_constructor;
      this._oldConstructor();
    };

    lib.comsuntexsymbolsJustTheFactsFrame.prototype =
      comsuntexsymbolsJustTheFactsFrame_prototype;

    JustTheFactsFrame._onTick = function () {
      if (JustTheFactsFrame._interactionLogged) {
        JustTheFactsFrame._instance.timeOnTask += 10;
        JustTheFactsFrame._interactionLogged = false;
      }
    };

    JustTheFactsFrame._logInteraction = function (e) {
      JustTheFactsFrame._interactionLogged = true;
    };

    JustTheFactsFrame._interactionTimer = new Timer(
      10000,
      JustTheFactsFrame._onTick,
    );
    JustTheFactsFrame._interactionLogged = false;

    const p = lib.comsuntexsymbolsJustTheFactsFrame.prototype;

    p.init = function (this: ThisJustTheFacts, stage) {
      UIUtil.setStage(stage);
      this.loadSound('beep.mp3', 'gameframe-click');
      this.loadSound('whoosh.mp3', 'gameframe-whoosh');
      this.loadSound('powerup.mp3', 'gameframe-powerup');

      if (JustTheFactsFrame.TEST) {
        TestUtil.SHOW_WARNINGS = true;
      } else {
        this.pwaMode = UIUtil.getParamAsBool('pwaMode');
        this.preview = UIUtil.getParamAsBool('preview');
        this.playerId = UIUtil.getParamAsInt('playerId');
        this.moduleId = UIUtil.getParamAsInt('moduleId');
        this.moduleVariant = UIUtil.getParamAsInt('moduleVariant');

        //if ( UIUtil.getParam("updateProgressUrl") != null )
        //this.updateProgressUrl = UIUtil.getParam("updateProgressUrl");
        TestUtil.SHOW_WARNINGS = false;
        if (UIUtil.getParamAsBool('soundDisabled')) this.scoreboard.mute();
      }

      JustTheFactsFrame._initButton(
        this.endScreen.nextBtn,
        JustTheFactsFrame._playNextGame,
      );
      JustTheFactsFrame._initButton(
        this.endScreen.moreBtn,
        JustTheFactsFrame._navigateMoreGames,
      );
      JustTheFactsFrame._initButton(
        this.practiceMenu.moreBtn,
        JustTheFactsFrame._navigateMoreGames,
      );

      UIUtil.createSimpleButton(
        this.changeRoundBtn,
        JustTheFactsFrame._clickChangeRounds,
      );

      stage.addEventListener(
        'stagemousedown',
        JustTheFactsFrame._logInteraction,
      );
    };

    p.moduleId = 0;
    p.moduleVariant = 0;

    p.gameStartFunction = null;
    p.gameStopFunction = null;
    p.loadedVars = null;

    // Loading
    p.getProgressUrl = '/api/player/get-just-the-facts-progress';
    p.gameDataFormat = LoadUtil.JSON;
    p.gameDataObject = null;
    p.updateProgressUrl = '/api/player/update-just-the-facts-progress';

    p.pwaMode = false;

    p.playerId = 0;
    p.preview = false;
    p.jtfSize = 0;
    p.skill = 1;
    p.gn = Calculator.ADD;
    p.round = 1;
    p.game = 1;
    p.quad = 1;
    p.score = 0;
    p.scoreMax = 100;
    p.bonus = 0;
    p.timeOnTask = 0;

    p.roundsInModule = 2;
    p.gamesPerRound = 1;
    p.bonusMax = -1;

    p.pretestFactString = '';
    p.posttestFactString = '';
    p.controlledFactString = '';
    p.correctPretest = 0;
    p.correctPosttest = 0;
    p.correctControlled = 0;
    p.correctHighest = 0;
    p.isControlled = 0;

    p.disableMoreBtn = false;
    p.disableNextBtn = false;

    // interface options
    p.automateScoreboard = false;
    p.displayProgress = false;
    p.displayPoints = true;
    p.automateDatabaseUpdates = true;
    p.soundDirectory = fimCdnUrl('/sounds/');

    p.initGame = function (
      this: ThisJustTheFacts,
      gameStartFunction,
      gameStopFunction,
    ) {
      this.gameStartFunction = gameStartFunction;
      this.gameStopFunction = gameStopFunction;

      UIUtil.hide(this.endScreen);
      UIUtil.hide(this.changeRoundBtn);
      this.scoreboard.hideProgressPanel();

      if (this.moduleId >= 24 && this.moduleId <= 40) {
        this.jtfSize = 1;
        this.roundsInModule = 4;
      } else if (this.moduleId >= 142 && this.moduleId <= 145) {
        this.jtfSize = 2;
        this.roundsInModule = 4;
      }

      if (this.jtfSize != 0) {
        this.practiceMenu.selectRound.text = 'Select a practice quad:';
      }

      for (let i = 1; i <= 4; i++) {
        const btn = this.practiceMenu['round' + i + 'Btn'];
        if (i <= this.roundsInModule) {
          JustTheFactsFrame._initButton(
            btn,
            JustTheFactsFrame._clickRoundBtn,
            i,
          );
          btn.x += (4 - this.roundsInModule) * 50;
        } else {
          UIUtil.hide(btn);
        }
      }

      if (this.preview) {
        UIUtil.hide(this.veil);
      } else {
        if (this.gameDataObject != null) {
          this._onVarsLoad(this.gameDataObject);
        } else {
          if (JustTheFactsFrame.TEST)
            LoadUtil.get(
              this.getProgressUrl,
              this._onVarsLoad,
              this.gameDataFormat,
              this,
            );
          else if (this.pwaMode) {
            TestUtil.log('isPWAMode');

            const vars = {} as apiPlayer.GetJustTheFactsProgress.Request;

            vars.playerId = this.playerId;
            vars.moduleId = this.moduleId;

            fimGameRepository.JustTheFacts.getProgress(vars)
              .then((values) => this._onVarsLoad(values))
              .catch((values) => this._onVarsLoad(values));
          } else {
            const request = {
              playerId: this.playerId,
              moduleId: this.moduleId,
            } satisfies apiPlayer.GetJustTheFactsProgress.Request;

            LoadUtil.get(
              `${this.getProgressUrl}?${toQueryString(request)}`,
              this._onVarsLoad,
              this.gameDataFormat,
              this,
            );
          }
        }
      }
    };

    p.startGame = function () {
      this.score = 0;
      this.bonus = 0;
      this.timeOnTask = 0;
      if (this.automateScoreboard) this.updateScoreboard();
      this.scoreboard.showProgressPanel();
      UIUtil.hide(this.endScreen, 500);
      JustTheFactsFrame._interactionTimer.start();
      this.gameStartFunction();
    };

    p.endGame = function () {
      JustTheFactsFrame._interactionTimer.stop();

      this.bonus = Math.round(this.bonus + 0.4);

      if (this.gameStopFunction != null) this.gameStopFunction();
      if (this.automateDatabaseUpdates) this.updateDatabase();
      let message = '';
      UIUtil.show(this.endScreen.stickersText);
      if (!this.preview) {
        UIUtil.hide(this.endScreen.nextBtn);
        UIUtil.hide(this.endScreen.moreBtn);
      } else {
        if (this.disableMoreBtn) {
          UIUtil.show(this.practiceMenu.moreBtn, 500);
        } else {
          UIUtil.hide(this.practiceMenu.moreBtn);
        }
      }
      if (this.displayPoints) {
        if (this.score < this.scoreMax * 0.1) {
          message = Chance.selectRandom([
            'Keep trying!',
            "Don't give up!",
            'Give it another try.',
            'Keep practicing!',
          ]);
          this.endScreen.beforeScoreText.text = 'You only scored';
          this.endScreen.afterScoreText.text = 'correct this time.';
        } else if (this.score < this.scoreMax * 0.4) {
          message = Chance.selectRandom([
            'Not bad!',
            'Good work.',
            'Keep it up!',
            'Keep practicing!',
          ]);
          this.endScreen.beforeScoreText.text = 'You scored';
          this.endScreen.afterScoreText.text = 'correct.';
        } else if (this.score < this.scoreMax * 0.8) {
          message = Chance.selectRandom([
            'Congratulations!',
            'Wow!',
            'Great job!',
            'Excellent!',
            'Well done!',
          ]);
          this.endScreen.beforeScoreText.text = 'You scored';
          this.endScreen.afterScoreText.text = 'correct!';
        } else {
          message = Chance.selectRandom([
            'Fantastic!',
            'Outstanding!',
            'Amazing!',
            'Superb!',
          ]);
          this.endScreen.beforeScoreText.text = 'You scored';
          this.endScreen.afterScoreText.text = 'correct!!';
        }
        this.endScreen.pointsText.text =
          this.score.toString() + ' of ' + this.scoreMax.toString();
      } else {
        this.endScreen.beforeScoreText.text = '';
        this.endScreen.pointsText.text = '';
        this.endScreen.afterScoreText.text = Chance.selectRandom([
          'You won!',
          'You did it!',
          'You got it right!',
        ]);
        message = Chance.selectRandom([
          'Fantastic!',
          'Outstanding!',
          'Great job!',
          'Excellent!',
          'Well done!',
          'Nice Work!',
        ]);
      }
      if (this.game == this.gamesPerRound) {
        message = 'You finished this round!';
        LoadUtil.playSound('gameframe-powerup');
      }
      this.endScreen.messageText.text = message;

      UIUtil.enable(this.endScreen);
      UIUtil.show(this.endScreen, 500);
      UIUtil.scaleTo(this.endScreen.watermark, 0.1);
      UIUtil.fadeTo(this.endScreen.watermark, 0.0);
      if (this.score > 15)
        UIUtil.delay(this._endGameAnimation, 500, null, this);
    };

    p._endGameAnimation = function () {
      UIUtil.scaleTo(this.endScreen.watermark, 1.0, 2000, 'elasticOut');
      UIUtil.fadeTo(this.endScreen.watermark, 1.0, 500);
    };

    /* Score */

    p.finished = function () {
      return this.score >= this.scoreMax;
    };

    p.updateScoreboard = function () {
      //this.scoreboard.updateRound( this.round );
      //this.scoreboard.updateGame( this.game );
      //this.scoreboard.updateProgress( this.score / this.scoreMax );
    };

    p.incrementScore = function (scoreIncrement) {
      scoreIncrement = Calculator.getInt(scoreIncrement, 1);
      this.setScore(this.score + scoreIncrement);
    };

    p.setScore = function (score) {
      this.score = score;
      this.score = Calculator.bound(this.score, 0, this.scoreMax);
      if (this.automateScoreboard) this.updateScoreboard();
    };

    p.incrementBonus = function (bonusIncrement) {
      this.bonus += bonusIncrement;
      if (this.bonusMax > 0 && this.bonus > this.bonusMax)
        this.bonus = this.bonusMax;
      this.scoreboard.updateBonus('' + this.bonus);
    };

    p.getLevel = function () {
      return Math.floor((6 * this.score) / this.scoreMax) + 1;
    };

    /* Data */

    p.getVar = function (key) {
      if (this.loadedVars != null) return this.loadedVars[key];
      else return 0;
    };

    p.setGameData = function (vars) {
      this.gameDataObject = vars;
    };

    p._onVarsLoad = function (
      vars: apiPlayer.GetJustTheFactsProgress.Response,
    ) {
      if (vars != null) {
        this.pretestFactString = vars.pretestFactString;
        this.posttestFactString = vars.posttestFactString;
        this.controlledFactString = vars.controlledFactString;
        this.correctPretest = Calculator.getInt(vars.correctPretest);
        this.correctPosttest = Calculator.getInt(vars.correctPosttest);
        this.correctControlled = Calculator.getInt(vars.correctControlled);
        this.correctHighest = Calculator.getInt(vars.correctHighest);
        this.isControlled = Calculator.getInt(vars.isControlled);
        this.quad = Calculator.getInt(vars.quad);

        if (this.jtfSize == 0) {
          this.round = this.pretestFactString.length == 0 ? 1 : 2;
        } else if (this.jtfSize == 1) {
          this.round = this.quad <= 4 ? 1 : 2;
        } else if (
          this.jtfSize == 2 &&
          this.quad == 8 &&
          this.correctHighest == 25
        ) {
          this.preview = true;
        }

        if (this.preview) {
          JustTheFactsFrame._clickChangeRounds(null);
        } else {
          UIUtil.hide(this.practiceMenu);
          this.startGame();
        }
      } else {
        this.preview = true;
      }

      this.loadedVars = vars;
      UIUtil.hide(this.veil);
    };

    p.nextGame = function () {
      UIUtil.disable(this.endScreen);

      if (this.preview || JustTheFactsFrame.TEST) {
        if (this.jtfSize == 0) {
          this.round++;

          if (this.round > this.roundsInModule) {
            this.round = this.roundsInModule;
          }
        } else if (this.jtfSize == 1) {
          this.quad++;
        }
        if (this.round > 0) {
          this.startGame();
        } else {
          JustTheFactsFrame._clickChangeRounds(null);
        }
      } else {
        if (this.pwaMode) {
          TestUtil.log('isPWAMode');

          const vars = {} as apiPlayer.GetJustTheFactsProgress.Request;

          vars.playerId = this.playerId;
          vars.moduleId = this.moduleId;

          fimGameRepository.JustTheFacts.getProgress(vars)
            .then((values) => this._onVarsLoad(values))
            .catch((values) => this._onVarsLoad(values));
        } else {
          const request = {
            playerId: this.playerId,
            moduleId: this.moduleId,
          } satisfies apiPlayer.GetJustTheFactsProgress.Request;

          LoadUtil.get(
            `${this.getProgressUrl}?${toQueryString(request)}`,
            this._onVarsLoad,
            this.gameDataFormat,
            this,
          );
        }
      }
    };

    p.updateDatabase = function (advanceProgress) {
      if (!Calculator.isDefined(advanceProgress)) advanceProgress = true;

      const vars = {} as apiPlayer.UpdateJustTheFactsProgress.Request;

      vars.playerId = this.playerId;
      vars.moduleId = this.moduleId;
      vars.score = this.score;
      vars.isControlled = this.isControlled;
      vars.gameData = this.gameData;
      vars.quad = this.quad;
      vars.timeOnTask = this.timeOnTask;

      //get the salt and then call the method with that name
      //note: here using the obscure fact that window.saltvalue has been
      //preloaded with the magic hash function
      const salt = window.salter();
      window[salt](vars);

      if (JustTheFactsFrame.TEST) {
        LoadUtil.post(
          'data/AsyncUpdate.ashx',
          null,
          this._onDatabasePost,
          LoadUtil.JSON,
          this,
        );
        TestUtil.log('updateDatabase()::' + vars);
      } else if (this.pwaMode) {
        TestUtil.log('isPWAMode');
        fimGameRepository.JustTheFacts.updateProgress(vars).then((result) =>
          this._onDatabasePost(result),
        );
      } else {
        if (!this.preview) {
          LoadUtil.post(
            this.updateProgressUrl,
            vars,
            this._onDatabasePost,
            LoadUtil.JSON,
            this,
          );
        }

        window.postTimeOnTaskByStatus(this.preview, true);
      }

      this.timeOnTask = 0;
    };

    p.resetRoundProgress = function () {
      this.game = 0;
      this.updateDatabase();
    };

    p._onDatabasePost = function (
      response: apiPlayer.UpdateJustTheFactsProgress.Response,
    ) {
      if (response != null) {
        //TODO: is this because the proc doesn't work, or because we're calling it wrong in the update api?
        //JASON: used to be the line below but stickers is no longer provided so this could never work
        //var stickers = Calculator.getInt(response.stickers, 0);
        const stickers = 0;
        if (!this.disableNextBtn) {
          UIUtil.show(this.endScreen.nextBtn, 500);
        }
        if (!this.disableMoreBtn) {
          UIUtil.show(this.endScreen.moreBtn, 500);
        }
        if (stickers > 0) {
          this.endScreen.stickersText.text =
            'You earned ' +
            stickers +
            (stickers > 1 ? ' stickers' : ' sticker');
          UIUtil.show(this.endScreen.stickersText, 500);
        }
      }
    };

    /* Main Menu */

    JustTheFactsFrame._initButton = function (btn, onClick, value) {
      UIUtil.createButton(
        btn,
        onClick,
        value,
        JustTheFactsFrame._onRoundButtonOver,
        JustTheFactsFrame._onRoundButtonOut,
      );
      UIUtil.hide(btn.btnHover);
    };

    JustTheFactsFrame._clickChangeRounds = function (e) {
      LoadUtil.playSoundAtVolume('whoosh', 0.5);
      if (JustTheFactsFrame._instance.gameStopFunction != null)
        JustTheFactsFrame._instance.gameStopFunction();
      UIUtil.show(JustTheFactsFrame._instance.practiceMenu, 500);
      UIUtil.hide(JustTheFactsFrame._instance.changeRoundBtn);
      JustTheFactsFrame._instance.scoreboard.hideProgressPanel();
    };

    JustTheFactsFrame._clickRoundBtn = function (e) {
      LoadUtil.playSoundAtVolume('click', 0.5);
      const btn = UIUtil.getEventTarget<{ value: number }>(e);
      if (this.jtfSize == 0) {
        JustTheFactsFrame._instance.round = btn.value;
        JustTheFactsFrame._instance.game = 1;
        JustTheFactsFrame._instance.quad = 1;
      } else {
        JustTheFactsFrame._instance.round = 1;
        JustTheFactsFrame._instance.game = 1;
        JustTheFactsFrame._instance.quad = btn.value;
      }
      UIUtil.show(JustTheFactsFrame._instance.changeRoundBtn);
      UIUtil.hide(JustTheFactsFrame._instance.practiceMenu, 500);

      JustTheFactsFrame._instance.startGame();
    };

    JustTheFactsFrame._onRoundButtonOver = function (e) {
      const btn = UIUtil.getEventTarget<{ bg: createjs.MovieClip }>(e);
      UIUtil.setFrame(btn.bg, 2);
    };

    JustTheFactsFrame._onRoundButtonOut = function (e) {
      const btn = UIUtil.getEventTarget<{ bg: createjs.MovieClip }>(e);
      UIUtil.setFrame(btn.bg, 1);
    };

    JustTheFactsFrame._playNextGame = function (e) {
      LoadUtil.playSoundAtVolume('gameframe-click', 0.5);
      JustTheFactsFrame._instance.nextGame();
    };

    JustTheFactsFrame._navigateMoreGames = function (e) {
      LoadUtil.playSoundAtVolume('click', 0.5);

      const hubUrl = UIUtil.getParam('hubUrl') || '';

      if (JustTheFactsFrame.TEST) {
        TestUtil.log(`UIUtil.navigate('${hubUrl}')`);
      } else {
        UIUtil.navigate(hubUrl);
      }
    };

    /* Misc */

    p.setBackgroundLoop = function (src: string) {
      //TODO: Revisit how to load sound files based on local vs hosted protype vs site integrated vs working offline like in a PWA.
      //var soundDirectory = JustTheFactsFrame.TEST ? "../sounds/loops/" : fimCdnUrl("/sounds/loops/");
      const soundDirectory = fimCdnUrl('/sounds/loops/');
      LoadUtil.startLoop(soundDirectory + src);
    };

    p.loadSound = function (src: string, id) {
      //TODO: Revisit how to load sound files based on local vs hosted protype vs site integrated vs working offline like in a PWA.
      //var soundDirectory = JustTheFactsFrame.TEST ? "../sounds/" : fimCdnUrl("/sounds/");
      const soundDirectory = fimCdnUrl('/sounds/');
      LoadUtil.loadSound(soundDirectory + src, id);
    };

    p.mute = function () {
      this.scoreboard.mute();
    };

    JustTheFactsFrame.TEST = false;
  }
}
